import type { RecordingRecord } from '../../lib/api'
import type { DailyStatusResult } from '../../lib/dailyStatus'
import { stateViewOf } from '../../lib/home'

/** The server's daily marker, never a sort position or a timestamp. */
export function dailyReading(rows: readonly RecordingRecord[]): RecordingRecord | null {
  return rows.find((row) => row.is_daily_reading === true) ?? null
}

export function dayReadingKind(row: RecordingRecord): string {
  if (row.condition === 'EO') return 'Eyes open block'
  return row.is_daily_reading === true ? "Day's reading" : 'Another reading'
}

/** EXP-003-C1: recent exercise does not establish that the activity was a walk. */
export function dayAxisKind(row: RecordingRecord): string {
  return row.is_daily_reading === true ? "day's reading" : 'another reading'
}

export function dayReadingWord(result: DailyStatusResult | null | undefined): string | null {
  if (result == null || !result.readable) return null
  const state = stateViewOf(result, null)
  return state?.map.word ?? result.scores.find((score) => score.label !== null)?.label ?? null
}

export function dayResearchBadge(result: DailyStatusResult | null | undefined): string | null {
  if (result == null || !result.readable) return null
  const state = stateViewOf(result, null)
  return state?.map.validated === false ? state.map.badge ?? 'Research' : null
}
